/**
 * Отслеживание `location.hash` для фиксации `#cmpimport=...` на всём жизненном цикле SPA.
 *
 * @module hooks/useSurveyInboundHash
 */

import { useEffect } from 'react';

import { ingestCmpimportFromWindowHash, ingestCmpimportFromWindowSearch } from '../utils/cmpimportHash';

/**
 * Подписывается на `hashchange` и обрабатывает текущий hash при монтировании.
 *
 * @returns {void}
 */
export function useSurveyInboundHash(): void {
  useEffect(() => {
    const handle = (): void => {
      if (
        typeof window === 'undefined' ||
        typeof window.location.hash !== 'string' ||
        typeof window.location.search !== 'string'
      ) {
        return;
      }

      ingestCmpimportFromWindowSearch(window.location.search);
      ingestCmpimportFromWindowHash(window.location.hash);
    };

    handle();

    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', handle);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('hashchange', handle);
      }
    };
  }, []);
}
